<template>
    <Recherche />
</template>

<script>
    import { defineComponent } from 'vue';
    import Recherche from './Recherche.vue'

    export default defineComponent({
        components: {
            Recherche
        },

        data: function () {
            return {
                message: "Bienvenue dans l'application fisimed"
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        }

    });
</script>
